import React, { useState, createContext, ReactElement, useEffect } from 'react';
import { getCurrentScript } from '../lib/DOM/Script';

function doesEqual(objA = {}, objB = {}) {
	return JSON.stringify(objA) === JSON.stringify(objB);
}

function getScriptArgs(
	defaultData = {},
	currentScript: HTMLElement | null | SVGScriptElement | undefined = null
) {
	const reactScript = currentScript || getCurrentScript();
	const data = reactScript?.dataset || [];

	if (Object.keys(data).length > 0) {
		return { ...data, id: reactScript?.id ? reactScript.id : '' };
	}

	return defaultData;
}

export const ScriptTagContext = createContext<{ [key: string]: string }>({});
export function ScriptTagProvider({
	children,
	defaultData = {},
	currentScript = null,
}: {
	children: ReactElement;
	defaultData?: {};
	currentScript?: HTMLElement | null | SVGScriptElement;
}) {
	const [dataAttrs, setDataAttrs] = useState(
		getScriptArgs(defaultData, currentScript)
	);

	useEffect(() => {
		const newAttributes = getScriptArgs(defaultData, currentScript);

		if (doesEqual(dataAttrs, newAttributes)) {
			return;
		}

		setDataAttrs(newAttributes);
	}, []);

	return (
		<ScriptTagContext.Provider value={dataAttrs}>
			{children}
		</ScriptTagContext.Provider>
	);
}
